import {DELETE_QUESTIONS_ERROR, DELETE_QUESTIONS_START, DELETE_QUESTIONS_SUCCESS} from "../../types";

export default function delete_questions(state, action) {
    switch (action.type) {
        case DELETE_QUESTIONS_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_QUESTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case DELETE_QUESTIONS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
